// extracted by mini-css-extract-plugin
export default {"videoVolume":"styles_videoVolume__EicPU","slider":"styles_slider__Il6+M"};